import { MarketType } from './markets';

type LocalizedRewritesType = Record<MarketType, string>;

export const localizedRoutes: Record<'product', {
    route: string;
    rewrites: LocalizedRewritesType;
}> = {
    product: {
        route: '/product',
        rewrites: {
            se: '/produkter',
            no: '/produkter',
            sefi: '/produkter',
            fi: '/tuotteet',
            dk: '/produkter',
        },
    },
};
